<template>
  <div>
    <div id="goz_esnetme">
      <paused
        v-if="pause"
        @click="
          $root.$emit('pause', !pause);
          pause = false;
        "
      ></paused>
      <a
        href="javascript:;"
        @click.stop="
          $root.$emit('pause', !pause);
          pause = !pause;
        "
        class="pause"
      >
        <i
          :class="pause == true ? 'el-icon-video-play' : 'el-icon-video-pause'"
        ></i>
      </a>

      <div
        style="
          width: 100%;
          height: 240px;
          position: absolute;
          bottom: 0px;
          left: 0px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: row;
          flex-wrap: wrap;
        "
      >
        <div
          v-for="(i, index) in stack"
          style="
            width: 150px;
            height: 120px;
            overflow: hidden;
            position: relative;
            display: flex;
            align-items: flex-end;
            justify-content: flex-end;
          "
          @click="show(index)"
        >
          <div
            style="
              width: 75px;
              position: absolute;
              bottom: 17px;
              z-index: 1;
              left: 37px;
              transition: 1s;
            "
            :style="{ bottom: i.show == true ? '27px' : '-63px' }"
          >
            <img src="/static/img/mole.png" style="width: 75px" />
            <div
              style="
                color: white;
                position: absolute;
                text-align: center;
                width: 75px;
                top: 44px;
              "
            >
              Kedi
            </div>
          </div>

          <img
            src="/static/img/molehill.png"
            style="width: 100%; position: relative; z-index: 2; top: 7px"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";
import moment from "moment";
export default {
  name: "KostebegiYakala",
  props: ["config"],
  data() {
    return {
      pause: false,
      stack: [],
    };
  },
  created() {
    for (let index = 0; index < 4; index++) {
      this.stack.push({
        show: false,
      });
    }
  },
  mounted() {
    this.wrapper = {
      width: document.getElementById("goz_esnetme").clientWidth,
      height: document.getElementById("goz_esnetme").clientHeight,
    };
  },
  beforeDestroy() {},
  methods: {
    show(index) {
      this.stack[index].show = true;
    },
  },
};
</script>

<style lang="less" scoped>
#goz_esnetme {
  width: 700px;
  max-width: 700px;
  height: 458px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  background-image: url("/static/img/3u5n_jgx6_210408.jpg") !important;
  flex-direction: column;
  background-size: 100%;
  cursor: url(/static/img/mallet.png), auto;
}
</style>




// WEBPACK FOOTER //
// src/components/modules/KostebegiYakala.vue